"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Text = _interopRequireDefault(require("./Text"));

var _Number = _interopRequireDefault(require("./Number"));

var _Color = _interopRequireDefault(require("./Color"));

var _Boolean = _interopRequireDefault(require("./Boolean"));

var _Object = _interopRequireDefault(require("./Object"));

var _Select = _interopRequireDefault(require("./Select"));

var _Radio = _interopRequireDefault(require("./Radio"));

var _Array = _interopRequireDefault(require("./Array"));

var _Date = _interopRequireDefault(require("./Date"));

var _Button = _interopRequireDefault(require("./Button"));

var _Files = _interopRequireDefault(require("./Files"));

var _default = {
  text: _Text.default,
  number: _Number.default,
  color: _Color.default,
  boolean: _Boolean.default,
  object: _Object.default,
  select: _Select.default,
  radios: _Radio.default,
  array: _Array.default,
  date: _Date.default,
  button: _Button.default,
  files: _Files.default
};
exports.default = _default;